export const ITV_STATUS = {
  da_pianificare: ["Da pianificare", "neutral"], pianificato: ["Pianificato", "blue"], assegnato: ["Assegnato", "brand"],
  in_corso: ["In corso", "amber"], sospeso: ["Sospeso", "red"], completato: ["Completato", "green"], annullato: ["Annullato", "neutral"],
};
export const SLA_STATE = {
  none: ["Nessuno SLA", "neutral"], in_corso: ["SLA in corso", "blue"], a_rischio: ["SLA a rischio", "amber"],
  violato: ["SLA violato", "red"], rispettato: ["SLA rispettato", "green"],
};
export const ITV_TYPES = [
  { key: "manutenzione", label: "Manutenzione" }, { key: "guasto", label: "Guasto" }, { key: "installazione", label: "Installazione" },
  { key: "sopralluogo", label: "Sopralluogo" }, { key: "assistenza", label: "Assistenza" },
];
export const typeLabel = (k) => (ITV_TYPES.find((t) => t.key === k) || { label: k }).label;
export const STEP_LABEL = { check_in: "Check-in", start: "Inizia intervento", end: "Termina intervento", check_out: "Check-out" };
const STEP_STATUS = { check_in: "assegnato", start: "in_corso", end: "in_corso", check_out: "completato" };

export const availableStep = (itv) => (itv?.next_step && STEP_STATUS[itv.next_step] === itv.status ? itv.next_step : null);

export const fmtHM = (m) => { const r = Math.round(m); return `${Math.floor(r / 60)},${String(r % 60).padStart(2, "0")}`; };
export const fmtMinutes = (m) => (m == null ? "—" : `${fmtHM(m)} h`);
// Unica conversione ore dell'app: "H", "H,5" (= mezz'ora), "H,MM" (MM = minuti reali 00-59) -> minuti; NaN se non valido; null se vuoto
export const parseHM = (s) => {
  const t = String(s ?? "").trim().replace(".", ",");
  if (!t) return null;
  const x = /^(\d{1,5})(?:,(\d{1,2}))?$/.exec(t);
  if (!x) return NaN;
  const d = x[2];
  if (d != null && d.length === 1 && d !== "0" && d !== "5") return NaN;
  const mm = d == null ? 0 : d.length === 1 ? (d === "5" ? 30 : 0) : Number(d);
  return mm > 59 ? NaN : Number(x[1]) * 60 + mm;
};

export const mapsUrl = (address) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
